import axios from 'axios'
import { toast } from 'react-toastify'
import { getCurrentLang } from "@hooks/useLng"
import { BrowserRouter as AppRouter, Route, Switch, Redirect } from 'react-router-dom'

export const loginAction = payload => {
    return dispatch => {
        dispatch({
            type: 'LOGIN',
            payload
        })
        localStorage.setItem('tk', payload.token);
        localStorage.setItem('user_data', JSON.stringify(payload.user))
    }
}

export const logoutAction = _ => {
    (async _ => {
        const currentLang = getCurrentLang() || 'en'
        const token = localStorage.getItem('tk')
        try {
            const res = await axios.get('/logout', {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept : 'application/json'
                }
            })
            toast.success(`${res.data.message[currentLang]} ✔` || "✔");
            localStorage.removeItem('tk');
            localStorage.removeItem('user_data');
            location.href = '/login'
        }catch (err){
            toast.error(`${err.response.data.message[currentLang]} ❌` || "❌");
        }
    })()
    return dispatch => {
        dispatch({
            type: 'LOGOUT',
        })
    }
}

